/**
 * Where a queued job is in its life.
 *
 * One vocabulary because three places read it — the two screens that start
 * work this way and the component that draws what it is doing — and a state
 * spelled differently in one of them is a state that screen cannot report.
 */
export type JobStatus = 'queued' | 'active' | 'completed' | 'failed'

/**
 * Whether a job is still going.
 *
 * Asked by every screen that polls one and by the poll interval itself; spelled
 * per caller, the two disagree the moment a state is added.
 */
export const isJobLive = (
  run: { status: JobStatus } | null | undefined,
): boolean =>
  run != null && run.status !== 'completed' && run.status !== 'failed'
